export default __webpack_public_path__ + "static/Privacy-Notice_EGTB_MY-2ab52fd98c24b5275b81b740ffdcae76.pdf";